import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';

export const path = '/personal-registry/personal/:personalId';
export const getPath = (personalId: number) => `/personal-registry/personal/${personalId}`;

// Loadable вызывается на уровне модуля, а не в теле компонента: каждый вызов возвращает
// НОВЫЙ тип компонента, а новый тип React монтирует заново вместо обновления. Router
// перерисовывает поддерево на любое изменение адреса, включая строку запроса, поэтому
// состояние реестра в URL приводило бы к размонтированию страницы на каждый ввод —
// поле поиска теряло фокус, а выделение сбрасывалось.
const MemberPage = Loadable({
  loader: () => import('./page'),
  loading: LoadableLoading,
});

const PagePersonalRegistryMember: React.FC = (props) => <MemberPage {...props} />;

export default PagePersonalRegistryMember;
